import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Popover, Radio, Popconfirm } from 'antd';
import { topBarResize } from '@/services/helper/topBarResize';
import {
  ANDES_V2_TOP_BAR_OPTIONS,
  SIMULATE,
  DEBUG,
  SEASIM,
  MODELING,
  TOP_BAR_RESULT,
  AMI_SETUP,
  REPORT,
  SERVICES_OPTIONS,
  RUN,
  DOWNLOAD,
  HSPICE_SIMULATE,
  HSPICE_SIMULATION,
  PADSTACKS,
  LAYOUT,
  STACKUP,
  ADVANCE_OPTIONS,
  GENERIC_SETTINGS
} from '../../../services/TopBarHelper';
import ExtractionOptionPanel from '../Channel/ExtractionOptionPanel';
import { PCB_CHANNEL, END_TO_END_CHANNEL, EXPERIMENTS } from '../../../constants/treeConstants';
import { startChannelExtraction } from '../store/simulation/extraction/action';
import { startEndToEndSimulation } from '../store/simulation/endToEndChannel/action';
import DebugPanel from './Debug';
import ChannelSeasimConfig from '../Channel/SeaSim';
import EndToEndSeasimConfig from '../EndToEndChannel/SeaSim';
import {
  getTopBarWidth,
  getTopMenuBackground,
  getTopMenuDisplay,
  getTopMenuDisabled,
  isEndToEndChildrenChannel,
  getDebugType,
  resultDisabled,
  getSerdesType
} from '@/services/Andes_v2';
import { getReportConfig, openPage, updateReportInfo, updateStackupStatusList } from '../store/project/action';
import Report from './Report';
import ChannelAMIModel from '../Channel/AMIModel';
import EndToEndAMIModel from '../EndToEndChannel/AMIModel';
import { changeSimulationSolver, clearPCBChannelInfo, getChannelContent, updateEndToEndSettingId, updateHSPICEConfig, updateHybridStatus } from '../store/channel/action';
import canvas from '@/services/LayoutCanvas';
import { getSelectedDesignIDs } from '@/services/helper/dataProcess';
import ServiceOptionsPanel from './serviceOptionsPanel';
import { startSweepExtraction } from '../store/simulation/sweep/action';
import ExperimentDownloadPanel from '../Sweep/DownLoad';
import { VERIFY_SUCCESS } from '../../../constants/verificationStatus';
import getIcon from '../../../services/helper/iconHelper';
import { CPHY } from '../../../services/PCBHelper/constants';
import { ADS, HSPICE } from '../../../services/Andes_v2/simulation';
import SettingPanel from '../SimulationContent/SettingPanel';
import PadstackPanel from '../../../components/PadstackPanel';
import StackupPanel from '../../../components/StackupPanel';
import { ANDES_V2 } from '../../../constants/pageType';
import Stackup from '../../LayoutExplorer/components/Stackup_v1';
import { getNewStackupList, STACKUP_CLOSE, STACKUP_OPEN } from '../../../services/Andes_v2/helper/stackupUIHelper';
import designConstructor from '../../../services/helper/designConstructor';
import AdvanceOptionPanel from './AdvanceOptionPanel';
import EndToEndExtractionOptionPanel from '../EndToEndChannel/ExtractionOptionPanel';
import { isPreLayout } from '../../../services/Andes_v2';
import GenericSettings from '../../../components/GenericSettings';
import { changeEndToEndSimulationSolver, updateEndToEndHSPICEConfig } from '../store/endToEndChannel/action';
import './index.css';

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: {},
      simulationloading: true
    }
  }

  screenChange() {
    window.addEventListener('resize', this._changeTopBarSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._changeTopBarSize);
  }

  componentDidMount() {
    const { forcePreviewShow, endToEndChannelId, viewList, endToEndSettingChannelId } = this.props;
    this._changeTopBarSize();
    this.screenChange();
    if (forcePreviewShow || (endToEndChannelId && endToEndSettingChannelId && viewList.includes(END_TO_END_CHANNEL))) {
      const { visible } = this.state;
      if (endToEndChannelId && endToEndSettingChannelId && viewList.includes(END_TO_END_CHANNEL)) {
        visible[SIMULATE] = true;
      } else {
        visible[MODELING] = true;
      }
      this.setState({ visible })
    }
  }

  _changeTopBarSize = () => {
    const { channelId, viewList, endToEndChannelId, simulationSolver } = this.props;
    topBarResize('andes-v2-top-bar', getTopBarWidth({ channelId, viewList, endToEndChannelId, simulationSolver }));
  }

  componentDidUpdate = (prevProps) => {
    const { channelId, endToEndChannelId, viewList } = this.props;
    const view = viewList.find(item => [PCB_CHANNEL, END_TO_END_CHANNEL].includes(item));
    const prevView = prevProps.viewList.find(item => [PCB_CHANNEL, END_TO_END_CHANNEL].includes(item));

    if (channelId !== prevProps.channelId || endToEndChannelId !== prevProps.endToEndChannelId || view !== prevView) {
      this.setState({
        visible: {
          ...this.state.visible,
          [MODELING]: false,
          [SEASIM]: false,
          [AMI_SETUP]: false,
          [STACKUP]: false,
          [PADSTACKS]: false,
          [HSPICE_SIMULATION]: false,
          [REPORT]: false,
          [SERVICES_OPTIONS]: false,
          [ADVANCE_OPTIONS]: false,
          [SIMULATE]: endToEndChannelId !== prevProps.endToEndChannelId ? false : this.state.visible[SIMULATE],
          [GENERIC_SETTINGS]: false
        }
      });
      this._changeTopBarSize();
      this.cleanAllCanvasBoundaries();
      this.props._updateHybridStatus(false);
      this.updateStackupList()
    }
  }

  cleanAllCanvasBoundaries = () => {
    const { selectedDesignIDs } = this.props;
    selectedDesignIDs.forEach(id => {
      const layout = canvas.getLayout(id);
      if (layout) {
        layout.cleanHybridBoundaries();
        layout.removeHybridAllPointsByName();
      }
    });
  }

  updateStackupList = () => {
    const { selectedKeys, channelDesignId } = this.props
    const allIds = { selectedKeys, channelDesignId, currentID: channelDesignId }

    // update stackupList when page change
    let { stackupList } = this.props
    stackupList = getNewStackupList(stackupList, STACKUP_CLOSE, allIds, false)
    this.props._updateStackupStatusList(stackupList)
  }

  openPanel = (key) => {
    const { projectId, channelId, endToEndChannelId, channelLoading, endToEndChannelLoading } = this.props;
    let { visible } = this.state;
    switch (key) {
      case DEBUG:
      case REPORT:
        if (!projectId) {
          return;
        }
        break;
      case SEASIM:
      case AMI_SETUP:
        if ((channelLoading || !channelId) && !endToEndChannelId) {
          return;
        }
        break;
      case MODELING:
        if (channelLoading || !channelId) {
          return;
        }
        break;
      case SERVICES_OPTIONS:
      case DOWNLOAD:
      case HSPICE_SIMULATION:
      case PADSTACKS:
      case ADVANCE_OPTIONS:
      case GENERIC_SETTINGS:
        if (visible[key]) {
          return;
        }
        break;
      case STACKUP:
        this.updateStackupPanel(true);
        return;
      case SIMULATE:

        if (endToEndChannelLoading || !endToEndChannelId) {
          return;
        }
        break;
      default: break;
    }
    visible[key] = true;
    this.setState({
      visible
    }, () => {
      if (key === REPORT) {
        this.getReportConfig();
      }
    });
  }

  updateStackupPanel = (status) => {
    const { visible } = this.state;
    let { stackupStatusList = [] } = this.props
    const { selectedKeys, channelDesignId } = this.props
    const allIds = { selectedKeys, channelDesignId, currentID: channelDesignId }

    if (status) {
      let existSamePanel = stackupStatusList.find(item => item.designId === channelDesignId && item.type === 'PCB')

      if (existSamePanel && existSamePanel.status === STACKUP_OPEN) {
        stackupStatusList = getNewStackupList(stackupStatusList, STACKUP_CLOSE, allIds, false)
      } else {
        stackupStatusList = getNewStackupList(stackupStatusList, STACKUP_OPEN, allIds, false)
        this.setState({
          visible: {
            ...visible,
            [STACKUP]: status
          }
        })
      }
    } else {
      stackupStatusList = getNewStackupList(stackupStatusList, STACKUP_CLOSE, allIds, false)
      this.setState({
        visible: {
          ...visible,
          [STACKUP]: status
        }
      })
    }

    this.props._updateStackupStatusList(stackupStatusList)
  }

  getReportConfig = (_channelOrEndToEndId, isMultiPCB, defaultTemplateId) => {
    const { channelId, projectId, endToEndChannelId, dataRate, channelType } = this.props;
    let _isEndToEnd = channelType === END_TO_END_CHANNEL,
      _channelId = channelId, _endToEndChannelId = endToEndChannelId, interfaceType;

    if (_channelOrEndToEndId) {
      _channelId = !isMultiPCB ? _channelOrEndToEndId : '';
      _endToEndChannelId = isMultiPCB ? _channelOrEndToEndId : '';
      _isEndToEnd = isMultiPCB;
    }
    interfaceType = getSerdesType(_channelId || _endToEndChannelId, _isEndToEnd);

    this.props._getReportConfig({
      channelId: _channelId,
      endToEndChannelId: _endToEndChannelId,
      isEndToEnd: _isEndToEnd,
      dataRate,
      projectId,
      interfaceType,
      defaultTemplateId
    });
  }

  closePanel = (key) => {
    this.setState({
      visible: {
        ...this.state.visible,
        [key]: false
      }
    });
  }

  simulationClick = () => {
    const { viewList, channelId, endToEndChannelId, pcbChannelSimSelectKeys, endToEndSimSelectKeys, experimentIds } = this.props;
    const view = viewList.find(item => [PCB_CHANNEL, END_TO_END_CHANNEL, EXPERIMENTS].includes(item));

    // Prevent clicking too fast
    if (!this.state.simulationloading) {
      return
    }
    this.setState({
      simulationloading: false
    })
    setTimeout(() => {
      this.setState({
        simulationloading: true
      })
    }, 1000);

    switch (view) {
      case PCB_CHANNEL:
        if (channelId) {
          const selectedKeys = pcbChannelSimSelectKeys.length ? pcbChannelSimSelectKeys : [channelId];
          this.props._startChannelExtraction([...selectedKeys], {});
        }
        break;
      case END_TO_END_CHANNEL:
        if (!endToEndChannelId) {
          break;
        }
        const selectedKeys = endToEndSimSelectKeys.length ? endToEndSimSelectKeys : [endToEndChannelId];
        this.props._startEndToEndSimulation([...selectedKeys])
        break;
      case EXPERIMENTS:
        this.props._startSweepExtraction(experimentIds, {});
        break;
      default: break;
    }
  }

  topBarItemClick = (e, key) => {
    const { endToEndChannelId, viewList } = this.props;
    switch (key) {
      case SIMULATE:
      case RUN:
        if (endToEndChannelId && viewList.includes(END_TO_END_CHANNEL)) {
          this.openPanel(key);
        } else {
          this.simulationClick();
        }
        break;
      case MODELING:
      case DEBUG:
      case SEASIM:
      case AMI_SETUP:
      case SERVICES_OPTIONS:
      case DOWNLOAD:
      case HSPICE_SIMULATION:
      case ADVANCE_OPTIONS:
      case GENERIC_SETTINGS:
        this.openPanel(key);
        break;
      case TOP_BAR_RESULT:
        this.openResult();
        break;
      default: break;
    }
  }

  openResult = () => {
    const { channelId, endToEndChannelId, viewList, channelResultExist, endToEndResultExist, sweepId } = this.props;
    const view = viewList.find(item => [PCB_CHANNEL, END_TO_END_CHANNEL, EXPERIMENTS].includes(item));
    const result = resultDisabled({
      view,
      channelId,
      channelResultExist,
      endToEndChannelId,
      endToEndResultExist,
      sweepId
    });
    if (!result) {
      return;
    }

    this.props._openPage({ pageType: result.pageType, id: result.id });
  }

  getDisabled = (key) => {
    const { channelId, viewList, endToEndChannelId, projectId, channelLoading, channelEndToEndId, channelResultExist,
      endToEndResultExist, experimentIds, sweepId, endToEndChannelLoading } = this.props;
    return getTopMenuDisabled({
      key,
      channelId,
      viewList,
      endToEndChannelId,
      projectId,
      channelLoading,
      channelEndToEndId,
      channelResultExist,
      endToEndResultExist,
      experimentIds,
      sweepId,
      endToEndChannelLoading
    })
  }

  getDisplay = (key) => {
    const { channelId, isEndToEndChildren, viewList, endToEndChannelId, channelResultExist, endToEndResultExist, simulationSolver, endToEndSettingChannelId } = this.props;
    return getTopMenuDisplay({
      key,
      channelId,
      isEndToEndChildren,
      viewList,
      endToEndChannelId,
      channelResultExist,
      endToEndResultExist,
      simulationSolver,
      endToEndSettingChannelId
    })
  }

  render() {
    const { width, viewList, channelId, endToEndChannelId, projectId, channelEndToEndId, pcbChannelSimSelectKeys,
      isEndToEndChildren, sweepId, experimentList, channelDesignId, layout, channelLoading, endToEndSettingChannelId,
      channelType, hspiceConfig, libraryStatus } = this.props;
    const { visible } = this.state;
    const debugType = getDebugType({ viewList, channelId, endToEndChannelId, channelEndToEndId, sweepId });
    const currentPCBs = designConstructor.getDesignValues(projectId);

    return (
      <Fragment>
        <div id='andes-v2-top-bar' style={{ width: width ? width : '100%' }}>
          {ANDES_V2_TOP_BAR_OPTIONS.map(item => {
            if (!this.getDisplay(item.key)) {
              return null;
            }
            return this.getItemMenu(item);
          })}
        </div>
        {visible[MODELING] && <ExtractionOptionPanel
          closePanel={() => this.closePanel(MODELING)}
          channelId={channelId}
          pcbChannelSimSelectKeys={pcbChannelSimSelectKeys}
          isEndToEndChildren={isEndToEndChildren}
          _startChannelExtraction={this.props._startChannelExtraction}
        />}
        {visible[DEBUG] && <DebugPanel
          closePanel={() => this.closePanel(DEBUG)}
          debugType={debugType}
          channelId={channelId}
          projectId={projectId}
          sweepId={sweepId}
          endToEndChannelId={channelId && channelEndToEndId && debugType === END_TO_END_CHANNEL ? channelEndToEndId : endToEndChannelId}
        />}
        {visible[SEASIM] && this.getSeaSimPanel()}
        {visible[AMI_SETUP] && this.getAMISetupPanel()}
        {visible[REPORT] && this.getReportPanel()}
        {visible[SERVICES_OPTIONS] && <ServiceOptionsPanel closePanel={() => this.closePanel(SERVICES_OPTIONS)} />}
        {visible[DOWNLOAD] && <ExperimentDownloadPanel
          downloadData={experimentList.filter(item => item.status === VERIFY_SUCCESS)}
          sweepId={sweepId}
          closePanel={() => this.closePanel(DOWNLOAD)}
        />}
        {visible[HSPICE_SIMULATION] && <SettingPanel
          hspiceConfig={hspiceConfig}
          channelId={channelType === END_TO_END_CHANNEL ? endToEndChannelId : channelId}
          libraryStatus={libraryStatus}
          _updateHSPICEConfig={channelType === END_TO_END_CHANNEL ? this.props._updateEndToEndHSPICEConfig : this.props._updateHSPICEConfig}
          channelType={channelType}
          closePanel={() => this.closePanel(HSPICE_SIMULATION)}
        />}
        {visible[PADSTACKS] && <PadstackPanel
          designId={channelDesignId}
          closePanel={() => this.closePanel(PADSTACKS)}
          layout={layout}
        />}
        {visible[STACKUP] && <StackupPanel
          {...this.props}
          pageType={ANDES_V2}
          designID={channelDesignId}
          Stackup={Stackup}
          designList={currentPCBs}
          closeModal={this.updateStackupPanel} />}
        {visible[ADVANCE_OPTIONS] && <AdvanceOptionPanel
          projectId={projectId}
          closePanel={() => this.closePanel(ADVANCE_OPTIONS)}
        />}
        {visible[GENERIC_SETTINGS] && <GenericSettings
          projectId={projectId}
          product={ANDES_V2}
          closePanel={() => this.closePanel(GENERIC_SETTINGS)}
        />}
        {visible[SIMULATE] && <EndToEndExtractionOptionPanel
          endToEndId={endToEndChannelId}
          closePanel={() => this.closePanel(SIMULATE)}
          channelLoading={channelLoading}
          endToEndSettingChannelId={endToEndSettingChannelId}
          _startEndToEndSimulation={this.simulationClick}
          _getChannelContent={this.props._getChannelContent}
          _updateEndToEndSettingId={this.props._updateEndToEndSettingId}
          _clearPCBChannelInfo={this.props._clearPCBChannelInfo}
        />}
      </Fragment>
    )
  }

  getSeaSimPanel = () => {
    const { channelType } = this.props;
    if (channelType === PCB_CHANNEL) {
      return <ChannelSeasimConfig
        isEndToEndChildren={this.props.isEndToEndChildren}
        closePanel={() => this.closePanel(SEASIM)}
      />
    }

    if (channelType === END_TO_END_CHANNEL) {
      return <EndToEndSeasimConfig
        closePanel={() => this.closePanel(SEASIM)}
      />
    }
    return null;
  }

  getExtractionOptions = (itemData) => {
    const disabled = this.props.channelLoading
    return <Dropdown
      key={itemData.key}
      menu={{
        items: this.extractionMenu(itemData),
        className: "extraction-dropdown-button",
        onClick: ({ key }) => this.topBarItemClick(null, key)
      }}
      disabled={disabled}
      trigger={['click']} >
      {this.getItemMenu(itemData)}
    </Dropdown >
  }

  extractionMenu = (itemData) => {
    return itemData.children.map(item => ({ key: item.key, label: item.title }))
  }

  getItemMenu = (itemData) => {
    const { channelType, serdesType, channelDesignId } = this.props;
    const { visible } = this.state;
    const disabledClassName = this.getDisabled(itemData.key);

    switch (itemData.key) {
      case REPORT:
        return this.getReportTitle(itemData, disabledClassName);
      case LAYOUT:
        return this.getLayoutTitle(itemData.children);
      default:
        if (itemData.key === SIMULATE && isPreLayout(channelDesignId)) {
          return this.getSimulateTitle(itemData, disabledClassName, visible);
        }
        const isUseHspice = getIsUseHSPICE(itemData.key, serdesType, channelType);
        return <div
          key={itemData.key}
          className={`andes-v2-top-bar-item ${disabledClassName} ${itemData.className}`}
          onClick={(e) => isUseHspice ? null : this.topBarItemClick(e, itemData.key)}
          style={getTopMenuBackground(itemData.key, visible)}
          title={disabledClassName && itemData.key === TOP_BAR_RESULT ? "No Result." : itemData.title
          }
        >
          {this.getMenuItemTitle(itemData, isUseHspice)}
        </div >
    }
  }

  getMenuItemTitle = (itemData, isUseHspice) => {
    if (itemData.key === TOP_BAR_RESULT) {
      return <Fragment>
        <span className='aurora-top-bar-vertical-line'></span>
        <div className='andes-v2-top-bar-result-title'>
          <span className='andes-v2-top-bar-item-title'>{itemData.title}</span>
          <span className={itemData.icon.className}>&gt;</span>
        </div>
      </Fragment>
    } else {
      const Icon = itemData.icon.iconType === "iconfont" ? null : getIcon(itemData.icon.type)
      return <Fragment>
        {isUseHspice ? this.simulationDropdown(itemData)
          : <>
            {itemData.icon.iconType === "iconfont" ? <span className={`iconfont ${itemData.icon.className}`} title={itemData.title}></span>
              : <Icon type={itemData.icon.type} className={itemData.icon.className} />}
            <span className='andes-v2-top-bar-item-title'>{itemData.title}</span>
          </>}
      </Fragment>
    }
  }

  selectSimulationType = (e, preKey, key) => {
    if (preKey !== key) {
      const value = key === HSPICE_SIMULATE ? HSPICE : ADS;
      const { channelType } = this.props;
      if (channelType === END_TO_END_CHANNEL) {
        this.props._changeEndToEndSimulationSolver(value);
      } else {
        this.props._changeSimulationSolver(value);
      }
    }
    this.topBarItemClick(e, key);
    this.setState({ popoVerVisible: false })
  }

  simulationDropdown = (itemData) => {
    const { popoVerVisible } = this.state;
    const { simulationSolver } = this.props;
    const value = simulationSolver === HSPICE ? HSPICE_SIMULATE : AMI_SETUP;
    const content = (<Radio.Group value={value}>
      {[{ title: 'ADS', key: AMI_SETUP }, { title: 'HSPICE', key: HSPICE_SIMULATE }].map(item =>
        <Radio
          key={`simulation-radio-${item.key}`}
          className="andes-v2-simulation-radio"
          value={item.key}
          onClick={(e) => this.selectSimulationType(e, value, item.key)}>
          {item.title}
        </Radio>
      )}
    </Radio.Group>)
    const Icon = itemData.icon.iconType === "iconfont" ? null : getIcon(itemData.icon.type)
    return <Popover
      placement="bottomLeft"
      content={content}
      trigger="click"
      classNames={{ root: 'andes-v2-popover' }}
      open={popoVerVisible}
      onOpenChange={(visible) => this.setState({ popoVerVisible: visible })}
    >
      <div className='andes-v2-top-bar-popover'>
        {itemData.icon.iconType === "iconfont"
          ? <span className={`iconfont ${itemData.icon.className}`} title={itemData.title}></span>
          : <Icon type={itemData.icon.type} className={itemData.icon.className} />}
        <span className='andes-v2-top-bar-item-title'>{itemData.title}</span>
      </div>
    </Popover >
  }

  // prelayout modeling title
  getSimulateTitle = (itemData, disabledClassName, visible) => {
    const Icon = itemData.icon.iconType === "iconfont" ? null : getIcon(itemData.icon.type);
    return <div
      key={itemData.key}
      className={`andes-v2-top-bar-item ${disabledClassName} ${itemData.className}`}
      style={getTopMenuBackground(itemData.key, visible)}
      title={itemData.title}
    >
      <Popconfirm
        title="Confirm Modeling?"
        onConfirm={(e) => this.topBarItemClick(e, itemData.key)}
        onCancel={() => { }}
        okText="Yes"
        cancelText="Cancel"
        classNames={{ root: "aurora-pop-confirm" }}
      >
        <div className='andes-v2-top-bar-popconfirm'>
          {itemData.icon.iconType === "iconfont"
            ? <span className={`iconfont ${itemData.icon.className}`} title={itemData.title}></span>
            : <Icon type={itemData.icon.type} className={itemData.icon.className} />}
          <span className='andes-v2-top-bar-item-title'>{itemData.title}</span>
        </div>
      </Popconfirm>
    </div >
  }

  getReportTitle = (itemData, disabledClassName) => {
    const { visible } = this.state;
    const { reportProgress, reportVisible } = this.props;
    return reportVisible && !visible[REPORT] ? <Fragment key={itemData.key}>
      <div className={`andes-v2-top-bar-item andes-v2-top-sus-report-item ${disabledClassName}`}
        onClick={() => !disabledClassName ? this.openPanel(REPORT) : null}
        style={reportVisible ? { background: '#c7e0f4' } : {}}
        title={itemData.title}
      >
        <div className='andes-v2-top-sus-report'>
          <span className="iconfont icon-baogao andes-v2-top-sus-report-icon andes-v2-top-sus-icon-diff" title={itemData.title}></span>
          <span className="andes-v2-top-bar-item-title">{itemData.title}</span>
        </div>
        <div className='andes-v2-top-sus-report-progress' style={{ width: `${reportProgress}%` }} />
      </div>
      <span className='andes-v2-report-progress-span'>{reportProgress}%</span>
    </Fragment>
      :
      <div className={`andes-v2-top-bar-item ${disabledClassName}`}
        key={itemData.key}
        onClick={!disabledClassName ? () => this.openPanel(REPORT) : null}
        style={getTopMenuBackground(itemData.key, visible)}
        title={itemData.title}
      >
        <div className='andes-v2-top-sus-report'>
          <span className="iconfont icon-baogao andes-v2-top-sus-report-icon andes-v2-top-sus-icon-diff" title={itemData.title}></span>
          <span className="andes-v2-top-bar-item-title">{itemData.title}</span>
        </div>
      </div>
  }

  getLayoutTitle = (children) => {
    const { channelDesignId } = this.props;
    const PCBExist = designConstructor.getDesign(channelDesignId);
    const disabled = PCBExist ? false : true;

    const menuItems = children.map(child => ({ key: child.key, label: child.title, disabled, onClick: () => this.openPanel(child.key) }))

    return <div
      className={!disabled ? 'andes-v2-top-bar-item' : 'andes-v2-top-bar-item andes-v2-top-bar-item-disabled'}
      key='Layout'
      title='Layout'
    >
      <Dropdown menu={{ items: !disabled ? menuItems : [] }} trigger={['click']}>
        <div onClick={e => e.preventDefault()}>
          <span className="iconfont icon-stack aurora-top-bar-stackup-icon" />
          <span className="andes-v2-top-bar-item-title">Layout</span>
        </div>
      </Dropdown>
    </div >
  }

  getAMISetupPanel = () => {
    const { channelType } = this.props;
    if (channelType === PCB_CHANNEL) {
      return <ChannelAMIModel
        isEndToEndChildren={this.props.isEndToEndChildren}
        closePanel={() => this.closePanel(AMI_SETUP)}
      />
    }

    if (channelType === END_TO_END_CHANNEL) {
      return <EndToEndAMIModel
        closePanel={() => this.closePanel(AMI_SETUP)}
      />
    }
    return null;
  }

  getReportPanel = () => {
    const { components, serdesType } = this.props;
    return <Report
      closePanel={() => this.closePanel(REPORT)}
      getReportConfig={this.getReportConfig}
      serdesType={serdesType}
      components={components}
    />
  }
}

const mapState = (state) => {
  const { AndesV2Reducer: {
    channel: { channelId, channelLoading, channelInfo, resultExist: channelResultExist, forcePreviewShow, endToEndSettingChannelId },
    project: { viewList, openProjectId, reportInfo = {}, selectedKeys, layout, stackupStatusList },
    endToEndChannel: { endToEndChannelId, resultExist: endToEndResultExist, endToEndChannelLoading, endToEndChannelInfo },
    simulation: { pcbChannelSimSelectKeys, endToEndSimSelectKeys },
    sweep: { experimentIds, sweepId, experimentData },
    library: { libraryStatus }
  } } = state;

  const { endToEndId, designId, config, content = {}, hspiceConfig: _hspiceConfig } = channelInfo || {};
  const { content: endToEndContent, hspiceConfig: endToEndHspiceConfig } = endToEndChannelInfo || {};
  const channelType = endToEndChannelId && viewList.includes(END_TO_END_CHANNEL) ? END_TO_END_CHANNEL
    : channelId && viewList.includes(PCB_CHANNEL) ? PCB_CHANNEL : ''
  const { components = [] } = content;

  let dataRate = '16';
  if (config && config.analysis) {
    const { options } = config.analysis;
    if (options && options.datarate) {
      dataRate = options.datarate && options.datarate.replace('GT/s', '');
    }
  }

  // HSPICE Simulation
  let simulationSolver = null, hspiceConfig = null;
  if (channelType === END_TO_END_CHANNEL) {
    simulationSolver = endToEndContent.simulationSolver;
    hspiceConfig = endToEndHspiceConfig;
  } else if (channelType === PCB_CHANNEL) {
    simulationSolver = content.simulationSolver;
    hspiceConfig = _hspiceConfig;
  }

  return {
    channelId,
    viewList,
    projectId: openProjectId,
    channelLoading,
    endToEndChannelId,
    pcbChannelSimSelectKeys,
    endToEndSimSelectKeys,
    channelEndToEndId: endToEndId,
    isEndToEndChildren: isEndToEndChildrenChannel({ endToEndId }) ? true : false,
    channelResultExist,
    endToEndResultExist,
    forcePreviewShow,
    reportProgress: reportInfo.reportProgress,
    reportVisible: reportInfo.reportVisible,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    channelDesignId: designId,
    dataRate,
    experimentIds,
    sweepId,
    experimentList: experimentData ? experimentData.variablesTables : [],
    components,
    serdesType: getSerdesType(channelId || endToEndChannelId, channelType === END_TO_END_CHANNEL),
    simulationSolver,
    layout,
    selectedKeys,
    stackupStatusList,
    endToEndChannelLoading,
    endToEndSettingChannelId,
    channelType,
    hspiceConfig,
    libraryStatus
  }
}

const mapDispatch = (dispatch) => ({
  _startChannelExtraction(channelIds, config) {
    dispatch(startChannelExtraction(channelIds, config))
  },
  _startEndToEndSimulation(endToEndChannelIds) {
    dispatch(startEndToEndSimulation(endToEndChannelIds, {}))
  },
  _openPage({ pageType, id }) {
    dispatch(openPage({ pageType, id }))
  },
  _updateReportInfo(info) {
    dispatch(updateReportInfo(info))
  },
  _updateHybridStatus(status) {
    dispatch(updateHybridStatus(status))
  },
  _getReportConfig({ channelId, projectId, endToEndChannelId, isEndToEnd, dataRate, interfaceType, defaultTemplateId }) {
    dispatch(getReportConfig({ channelId, projectId, endToEndChannelId, isEndToEnd, dataRate, interfaceType, defaultTemplateId }))
  },
  _startSweepExtraction(experimentIds) {
    dispatch(startSweepExtraction(experimentIds))
  },
  _changeSimulationSolver(simulationSolver) {
    dispatch(changeSimulationSolver(simulationSolver))
  },
  _updateStackupStatusList(stackupStatusList) {
    dispatch(updateStackupStatusList(stackupStatusList))
  },
  _getChannelContent(id) {
    dispatch(getChannelContent(id));
  },
  _updateEndToEndSettingId(id) {
    dispatch(updateEndToEndSettingId(id));
  },
  _clearPCBChannelInfo() {
    dispatch(clearPCBChannelInfo());
  },
  _changeEndToEndSimulationSolver(simulationSolver) {
    dispatch(changeEndToEndSimulationSolver(simulationSolver))
  },
  _updateHSPICEConfig(hspiceConfig, channelId) {
    dispatch(updateHSPICEConfig(hspiceConfig, channelId))
  },
  _updateEndToEndHSPICEConfig(hspiceConfig, endToEndChannelId) {
    dispatch(updateEndToEndHSPICEConfig(hspiceConfig, endToEndChannelId));
  },
});

function getIsUseHSPICE(key, serdesType, channelType) {
  if (serdesType === CPHY && key === AMI_SETUP) {
    return !!channelType;
  }
}

export default connect(mapState, mapDispatch)(TopBar)